import cash from 'cash-dom';
export default cash;